import RoadmapBanner from "./banner";

export default function Roadmaps() {
  return (
    <RoadmapBanner />
  )
}
